import { useState } from 'react';
import { ChipAction } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { ChipDropdown } from 'shared/domains/common-ui';
import { formatDateLabel } from './utils/formatDateLabel';
import { CalendarDropdown } from '../CalendarDropdown';
export function DateFilter(props) {
    const { onSubmit, clear, label, value } = props;
    const formattedDateLabel = formatDateLabel(label, [value === null || value === void 0 ? void 0 : value.startDate, value === null || value === void 0 ? void 0 : value.endDate]);
    const [open, setOpen] = useState(false);
    const closeDropdown = () => setOpen(false);
    const toggleDropdown = () => setOpen(!open);
    const handleSelect = (dateRange) => {
        onSubmit(dateRange);
        closeDropdown();
    };
    return (<ChipDropdown open={open} onClose={closeDropdown} onClick={toggleDropdown} label={formattedDateLabel} action={value && (<ChipAction onClick={clear}>
            <Falcon icon="remove"/>
          </ChipAction>)}>
      <CalendarDropdown initialValue={value} onSubmit={handleSelect}/>
    </ChipDropdown>);
}
